import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

export const patchObservationFormInstance = async (
	formInstance: Partial<IFormInstance>
) => {
	const url = `/observations/instances/${formInstance.id}/`;

	const response = await cmsClient.patch<IFormInstance>(url, formInstance);
	return response.data;
};

const usePatchObservationFormInstance = () => {
	const mutation = useMutation(patchObservationFormInstance);

	return mutation;
};

export default usePatchObservationFormInstance;
